<template>
  <div class="edit-page-wrapper ls-edit-wrap">
    <div class="">
      <campaigns-config-size />
    </div>
    <div v-if="campaign.steps[0]" id="leadslide-page-edit" ref="lsPage">
      <blocks-outer-block
          :page="campaign.steps[0]"
          :save_block="save_block"
          :save_page="save_page"
      ></blocks-outer-block>

      <v-navigation-drawer v-model="show_drawer" fixed right hide-overlay>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">
              LeadSlide Blocks
            </v-list-item-title>
            <v-list-item-subtitle>
              Click and Slide blocks onto page
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <ul id="block-list">
          <draggable class="list-group"
                     :list="outer_blocks"
                     :group="{ name: 'blocks', pull: 'clone', put: false }"
                     @change="log">
            <li
                class="outer-block-wrapper outer-block "
                v-for="(block, index) in outer_blocks">
              <v-img width="200px" class="ma-auto" :src="'/'+block.block_image">

              </v-img>
            </li>
          </draggable>
        </ul>
      </v-navigation-drawer>

      <v-btn
          color="light-blue lighten-1 white--text"
          small
          rounded
          fab
          class="add_outer_block"
          @click="load_drawer(!!show_drawer)"
      >
        <v-icon v-if="!show_drawer">
          mdi-plus
        </v-icon>
        <v-icon v-if="show_drawer">
          mdi-minus
        </v-icon>
      </v-btn>
    </div>

  </div>
</template>

<script>
import {mapActions, mapMutations, mapGetters} from 'vuex'
import draggable from "vuedraggable";
import BlocksOuterBlock from '@/components/Blocks/OuterBlock'
import CampaignsConfigSize from '@/components/Campaigns/ConfigSize'


export default {
  components: {
    draggable,
    BlocksOuterBlock,
    CampaignsConfigSize
  },
  computed: {
    ...mapGetters([
      'page',
      'screen_type',
      'campaignLoading',
      'isPageTemplate',
      'save_dialog',
      'campaign',
      'outer_blocks'
    ])
  },
  data() {
    return {
      show_drawer: false,
      is_saving: false,
      action_loading: false,
      step: {},
      loadingMessage: 'Saving Please Wait...'
    }
  },
  created() {
    this.$store.dispatch('clearHistory');
    this.initialise();
    this.$store.commit('updateLoading', false);
  },
  watch: {
    'page.name': function (nv) {
      this.page.slug = nv.replace(/\W/g, '-');
      console.log(nv);
    }
  },
  methods: {
    log: function (evt) {
      window.console.log(evt);
    },
    load_drawer(show_drawer) {
      this.show_drawer = !show_drawer
    },
    initialise() {
      let campaign = JSON.parse(localStorage.getItem('campaign'));
      this.$store.dispatch('setCampaign', campaign);
    },
    send_alert() {
    },
    save_block: function (block) {
      //save as a custom block
    },
    pre_save: function (step, current_step, change_to_step) {
      let self = this;
      this.is_saving = true;

      this.campaign.steps[0] = step;
      this.campaign.step = 1;
      this.campaign.state === 9 ? self.loadingMessage = 'Saving Draft Campaign Please Wait...' : self.loadingMessage = 'Saving Campaign Please Wait...';
      localStorage.setItem('campaign', JSON.stringify(self.campaign));

      this.$store.dispatch('updateAndSaveCampaignStep', self.campaign).then(function (r) {
        self.$store.dispatch('updateCampaignLoading', false);
        self.$notify({
          title: 'Saved:',
          text: 'Campaign Page Saved',
          group: 'notifications',
          position: 'top right'
        });
        if (change_to_step !== 1) {

        }
      }).catch(function (e) {
        self.$notify({
          title: 'Error:',
          text: 'There was an error saving your campaign. Please contact support.',
          group: 'notifications',
          position: 'top right'
        });
      }).finally(() => {
        self.$store.dispatch('updateCampaignLoading', false);
        self.$store.dispatch('setLoading', {
          loading: false,
          message: "Saving Please Wait..."
        });
      });
      // setTimeout(() => {
      //   this.take_screenshot().then(function (image_data_url) {
      //     step.presave_image = image_data_url;
      //   });
      // }, 1000);
    },
    async take_screenshot() {
      const options = {
        type: 'dataURL',
        width: 980,
        height: 450
      };
      const el = this.$refs.lsPage

      // return await this.$html2canvas(el, options);
    },
    save_page: function (page) {
      this.$store.dispatch('savePage', {
        isTemplate: this.isTemplate,
        page: page
      });
    },
    delete_block: function (index) {
    },
    load_blocks(type = 'outer', category = null) {
      this.$store.dispatch('getBlocks', type, category).then(data => {
        this.outer_blocks = data.outer_blocks;
      }).catch((error) => {
        console.log(error);
        this.$notify({
          title: 'Error:',
          text: 'Error loading blocks.',
          group: 'notifications',
          position: 'top right'
        });
      });
    },
    load_default_template(id) {
      if (id >= 0) {
        this.$store.dispatch('getPage', this.id).then(data => {
          this.page = data;
        }).catch((error) => {
          console.log(error);
          this.$notify({
            title: 'Error:',
            text: 'Page load error',
            group: 'notifications',
            position: 'top right'
          });
        });
      }
    },
    load_user_template() {
      this.$hget(
          '/basic/pages/' + this.id + '/').then((response) => {
        console.log('loaded user data');
        console.log(response.data);
        if (typeof response.data !== 'undefined') {
          this.page = response.data;
        }
      });
    },
    parse_json_blocks(json_string) {
      let pj = JSON.stringify(json_string.replace(/True/g, 'true'));
      pj = pj.replace(/False/g, 'false');
      return pj;
    },
  }
}
</script>


<style lang="scss">

#block-list {
  margin-top: 20px;
  padding-left: 0;
  max-height: 100%;
  overflow: auto;

  li {
    display: block;

    &:hover {
      cursor: grab;
    }
  }
}

.add_outer_block {
  position: fixed;
  bottom: 100px;
  right: 45px;
  z-index: 6;
}

.outer-block.has_background {
  background-size: cover !important;
  background-position: center center !important;
}

.outer-block.has_background.parallax-background {
  min-height: 100%;
  min-width: 100%;
  background-attachment: fixed !important;
}

.ob-designer {

  padding: 0 !important;
  margin: 0 !important;

  li {
    display: block;
    position: relative;
    background: white;
  }
}

.tox-collection__group {
  div {
    .tox-collection__item-label {
      line-height: inherit !important;

      p, h1, h2, h3, h4, h5, h6 {
        color: white !important;
      }

    }

    h1 {
      font-size: 34px !important;
    }
  }
}

.edit-page-wrapper {
  position: relative;
}

.ls-image, .v-image__image {
  &:hover {
    cursor: pointer;
  }
}

.mobile {
  width: 375px;
  height: 667px;
  transform-origin: 0 0;
  transform: scale(0.67);
}

.ls-edit-wrap {


  .edit-wrapper {
    position: fixed;
    top: 0;
    z-index: 500;
    width: 100%;
  }
}

.italic {
  font-style: italic;
}

.text-shadow {
  text-shadow: 2px 2px 2px rgb(64, 64, 64);
}

.rounded-image {
  border-radius: 500px;
}

.block-shadow {

}

.underline {
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
  }
}

.edit-page-wrapper {

  .fixed-header {
    position: fixed;
    height: 45px;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 800;
  }

  .fixed-drawer-items {
    width: 100%;
    height: 200px;
    position: fixed;
    transition: top 0.5s ease;
  }

  .add-block-button {
    position: fixed;
    top: 90%;
    right: 20px;
    z-index: 100;
  }

  .fixed-blocks {
    /*position: fixed;*/
    /*height:600px;*/
    /*top:15px;*/
  }

  .outer-block {
    &:hover {
      //margin: 4px;
      box-shadow: inset 0 0 5px #00fff7;
      z-index: 1;

      .outer-block-options {
        display: block;
      }
    }

    .outer-block-options {
      height: 46px;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 200;
      display: none;
    }

  }

  .inner-block-wrapper {
    outline: 2px dashed #15c2ff;

    &:hover {
      /*margin:4px;*/

      /*z-index:31;*/
    }
  }

  .active {
    border: 1px solid #5ab273;
    border-color: #5ab273;
    box-shadow: 0 0 0 3px rgba(21, 255, 63, 0.62) !important;
  }

  .no-radius {
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-radius: 0px;
  }

  .inner_block {

    .content_wrapper {
      position: relative;
    }

    .bold {
      font-weight: 800;
    }


  }

  .toolbar {
    position: absolute;
    top: -45px;
    left: 0;
    right: 0;
    margin: auto;
    height: 45px;
    background: pink;
  }

  .toolbar.text {
    width: 368px;
  }

  .rounded-image {
    border-radius: 500px;
  }
}
</style>
